import { css } from "@mui/material";

export const textEllipsis = css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: clip;
  word-break: break-all;
`;
